import SelectModeEnum from "@/enums/SelectModeEnum";
import FilterTreeStore from "../FilterTreeStore";
import { MultiBaseMode } from "./MultiBaseMode";
import TreeNode from "@/types/TreeNode";
import PinTypeEnum from "@/enums/PinTypeEnum";
import Pin from "@/types/FilterTree/Pin";
import BaseObjectTypeEnum from "@/enums/BaseObjectTypeEnum";
import Criteria from "@/types/FilterTree/Criteria";
import SubFilter from "@/types/FilterTree/SubFilter";
import { FilterTreeUtils } from "@/components/commons/Utils";

export class MultiSimpleMode extends MultiBaseMode  {
    /** 
     * Constructeur avec paramètre
     * @param context Instance de FilterTree
     */
    public constructor(context: FilterTreeStore) {
        super(context);
		this.selectMode = SelectModeEnum.MultiSimple;
        this.store.context.commit('setButtonState', { hasSelectAll: false });
    }

	protected override setPins(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean) {
        for (let pin of pins) {
            if (pin.Type == PinTypeEnum.Tree) {
                let nodeIndex = nodes.findIndex(x => x.Id == pin.Reference);
                if (nodeIndex > -1) {
                    let node = nodes[nodeIndex];
                    //Attention cette ligne permet de remettre la bonne instance du noeud pour le mode single
                    pin.TreeNode = node;
                }
            }

            let selecteds: TreeNode[] = [];
            let values: string[] = JSON.parse(JSON.stringify(pin.Selections));
            //Il faut parcourir les différentes valeur id de noeud sélectionné
            for (let node of nodes) {
                for (let value of values) {
                    if (node.Id === value || node.Reference === value) {
                        node.Selections.push({ Id: pin.Id, Type: pin.Type, Included: pin.Included, Affiliation: 0 });
                        this.UpdateNode(isHistoricMode, isCheckOnly, node);
                        selecteds.push(node);
                        break;
                    }
                }
            }

            for (let treeNode of nodes) {
                for (let selected of selecteds) {
                    if (selected.LeftBound > treeNode.LeftBound && selected.RightBound < treeNode.RightBound) {
                        let indexSelect = treeNode.Selections.findIndex(x => x.Id == pin.Id);
                        if (indexSelect === -1) {
                            treeNode.Selections.push({ Id: pin.Id, Type: pin.Type, Included: pin.Included, Affiliation: 2 });
                            this.UpdateNode(isHistoricMode, isCheckOnly, treeNode);
                        }
                    }
                }
                
                treeNode.WithCheckBox = true;
                treeNode.Selected = false;
            }
        }

        let maxPinId = 0;
        for(let pin of pins) {
            if (pin.Id > maxPinId)
                maxPinId = pin.Id;
        }

        this.store.context.commit('setBases', { nodes: nodes, pins: pins, maxPinId: maxPinId });
        this.UpdateInvolvedNodes(nodes, isHistoricMode);
    }

    /** Cette méthode est appelée lors du click sur un noeud treeNode */
    public override SelectNodes(selectedNodes: TreeNode[], included: boolean, nodes : TreeNode[], pins : Pin[], maxPinId: number, isHistoricMode: boolean, isCheckOnly : boolean){
        for (let selectedNode of selectedNodes) {
            let indexPin = pins.findIndex(x => x.Type == PinTypeEnum.Tree && x.TreeNode.Id == selectedNode.Id);
            
            if (indexPin != -1) {
                //Si la pin existe il faut la supprimer
                let pin: Pin = pins[indexPin];

                for (let treeNode of nodes) {
                    if (selectedNode.LeftBound <= treeNode.LeftBound && selectedNode.RightBound >= treeNode.RightBound
                        || selectedNode.LeftBound > treeNode.LeftBound && selectedNode.RightBound < treeNode.RightBound) {
                        let indexSelect = treeNode.Selections.findIndex(x => x.Id == pin.Id);
                        if (indexSelect != -1) {
                            treeNode.Selections.splice(indexSelect, 1);
                            this.UpdateNode(isHistoricMode, isCheckOnly, treeNode);
                        }
                    }
                }

                pins.splice(indexPin, 1);
            } else {
                //Si la pin n'existe pas il faut l'ajouter
                let pin: Pin = FilterTreeUtils.SetPinTree(selectedNode, false, maxPinId);
                pins.push(pin);

                let nodeIndex = nodes.findIndex(x => x.Id == selectedNode.Id);
                selectedNode = nodes[nodeIndex];
                //Attention cette ligne permet de remettre la bonne instance du noeud pour le mode single
                pin.TreeNode = selectedNode;

                selectedNode.Selections.push({ Id: pin.Id, Type: pin.Type, Included: pin.Included, Affiliation: 0 });
                this.UpdateNode(isHistoricMode, isCheckOnly, selectedNode);

                let removePins: number[] = [];

                if (pin.Included && pins.length > 0) {
                    for (let treeNode of nodes) {
                        if (selectedNode.LeftBound < treeNode.LeftBound && selectedNode.RightBound > treeNode.RightBound) {
                            let selectIndex = treeNode.Selections.findIndex(x => x.Included && x.Type == PinTypeEnum.Tree && x.Affiliation === 0);
                            if (selectIndex != -1) {
                                let removeIndex = pins.findIndex(x => x.Id === treeNode.Selections[selectIndex].Id);
                                removePins.push(pins[removeIndex].Id);
                            }
                        }
                    }
                }

                if (removePins.length > 0) {
                    for (let treeNode of nodes) {
                        if (selectedNode.LeftBound <= treeNode.LeftBound && selectedNode.RightBound >= treeNode.RightBound
                            || selectedNode.LeftBound > treeNode.LeftBound && selectedNode.RightBound < treeNode.RightBound) {
                            for (let removePin of removePins) {    
                                let selectIndex = treeNode.Selections.findIndex(x => x.Id === removePin);
                                if (selectIndex != -1) {
                                    treeNode.Selections.splice(selectIndex, 1);
                                }
                            }
                        }
                    }
                    for (let removePin of removePins) {
                        let removeIndex = pins.findIndex(x => x.Id === removePin);
                        pins.splice(removeIndex, 1);
                    }
                }

                for (let treeNode of nodes) {
                    if (selectedNode.LeftBound > treeNode.LeftBound && selectedNode.RightBound < treeNode.RightBound) {
                        treeNode.Selections.push({ Id: pin.Id, Type: pin.Type, Included: pin.Included, Affiliation: 2 });
                        this.UpdateNode(isHistoricMode, isCheckOnly, treeNode);
                    } 
                }
            }
        }

        maxPinId = 0;
        for(let pin of pins) {
            if (pin.Id > maxPinId)
                maxPinId = pin.Id;
        }

        this.store.context.commit('setBases', { nodes: nodes, pins: pins, maxPinId: maxPinId });
        this.UpdateInvolvedNodes(nodes, isHistoricMode);
    }

 	public override SelectAllNodes(nodes: TreeNode[], isHistoricMode: boolean, isCheckOnly: boolean) {
        throw new Error('Method not implemented.');
    }

    /**
	 * Permet de raffraichir l'état du noeud
	 * @param isHistoricMode
	 * @param isCheckOnly
	 * @param node
	 * @returns
	 */
	public override UpdateNode(isHistoricMode: boolean, isCheckOnly: boolean, node: TreeNode) { 
		let selections = node.Selections;
		let historic: boolean = !(!node.Depreciated || (node.Depreciated && isHistoricMode));

		if (selections.length > 0) {
			/** Test si objet courant qui n'est pas inclus */
			let o0 = selections.findIndex(x => x.Affiliation === 0 && !x.Included) !== -1;
			/** Test si objet courant est inclus (s'il fait parti des checkleaders) */
			let o1 = selections.findIndex(x => x.Affiliation === 0 && x.Included) !== -1;
			/** Test s'il s'agit d'un ascendant qui n'est pas inclus */
			let p0 = selections.findIndex(x => x.Affiliation === 2 && !x.Included) !== -1;

			if (o0 && !o1 || o0 && o1) {
				node.Checked = false;
				node.CheckLeader = false;
				node.Indeterminate = false;
				node.NestedChecked = false;
				node.Disabled = false;
				node.Forced = false;
				node.Hidden = isCheckOnly || historic;
			} else if (!o0 && o1) {
				if (!historic) {
					node.Checked = true;
					node.CheckLeader = false;
					node.Indeterminate = p0;
					node.NestedChecked = false;
					node.Disabled = false;
					node.Forced = false;
					node.Hidden = historic;
				} else {
					node.Checked = true;
					node.CheckLeader = false;
					node.Indeterminate = false;
					node.NestedChecked = false;
					node.Disabled = false;
					node.Forced = false;
					node.Hidden = historic;
				}
			} else {
				/** Test si parent inclus */
				let p1 = selections.findIndex(x => x.Affiliation === 2 && x.Included) !== -1;

				if (p1) {
					node.Checked = false;
					node.CheckLeader = false;
					node.Indeterminate = false;
					node.NestedChecked = true;
					node.Disabled = false;
					node.Forced = isCheckOnly;
					node.Hidden = isCheckOnly || historic;
				} else {
					node.Checked = false;
					node.CheckLeader = false;
					node.Indeterminate = false;
					node.NestedChecked = false;
					node.Disabled = false;
					node.Forced = false;
					node.Hidden = isCheckOnly || historic;
				}
			}
		} else {
			node.Checked = false;
			node.CheckLeader = false;
			node.Indeterminate = false;
			node.NestedChecked = false;
			node.Disabled = false;
			node.Forced = false;
			node.Hidden = isCheckOnly || historic;
		}
	}
}